import cloneDeep from 'lodash/cloneDeep';
import { defaultProps } from './defaultEventProps';
import { getValidatedEventData } from '../eventDataValidator';

export const researchReportView = (props) => {
    const {
        reportId,
        reportName,
        reportSubtitle,
    } = props;

    const eventProps = cloneDeep(defaultProps);
    const title = reportSubtitle ? `${reportName} - ${reportSubtitle}` : reportName;

    const propsMapping = [
        { name: 'Research Report ID', value: reportId },
        { name: 'Research Report Name', value: title },
    ];

    eventProps.baseProps = getValidatedEventData({ eventData: propsMapping });
    eventProps.providerProps.superProps.incrementalProps['Read Research Report'] = 1;

    return {
        name: 'View Research Report',
        details: eventProps,
    };
};
